<template>
  <b-container>
    <header class="header">
      <TheTitle class="header__title">最新消息</TheTitle>
      <label class="addButton header__search">
      <ButtonAdd @click="$router.push(`${$route.path}/add`)"
                v-if="role === 'admin'">
        新增最新消息
      </ButtonAdd>
      </label>
    </header>
    <h4>消息列表</h4>
    <section class="table-content">
      <DataTable
        v-show="list"
        :fields="fields"
        :items="list"
        :total-result="total"
        :options.sync="options"
        :loading="loading"
        @row-clicked="goToItem"
        @row-selected="onRowSelected"
      >
      </DataTable>
      <b-skeleton-table v-if="!list" :rows="15" :columns="5"></b-skeleton-table>
    </section>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { scheduled, asyncScheduler } from 'rxjs';
import {
  switchMap, debounceTime, map, pluck, mergeAll,
} from 'rxjs/operators';
import {
  BContainer,
  BSkeletonTable,
} from 'bootstrap-vue';
import dataTableMixin from '../../mixins/data-table';
import DataTable from '../../components/DataTable.vue';
import TheTitle from '../../components/TheTitle.vue';
import ButtonAdd from '../../components/button/ButtonAdd.vue';

export default {
  mixins: [dataTableMixin],
  components: {
    DataTable,
    TheTitle,
    ButtonAdd,
    BContainer,
    BSkeletonTable,
  },
  data: () => ({
    fields: [
      { key: 'title', label: '消息標題', sortable: true },
      { key: 'createdAt', label: '創建時間', sortable: true },
      { key: 'updatedAt', label: '更新時間', sortable: true },
    ],
    filter: {
      title: undefined,
      createdAt: undefined,
    },
    options: {
      page: 1,
      size: 15,
      order: 'desc',
    },
    selected: [],
  }),
  computed: {
    ...mapGetters(['role']),
  },
  subscriptions() {
    const getData$ = (data) => this.httpRequest$({
      method: 'GET',
      url: `/agc-${this.role}-api/notification`,
    }, data);

    return {
      list: scheduled([
        ...this.scheduleTasks,
      ], asyncScheduler).pipe(
        mergeAll(),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
          },
          options: this.options,
        })),
        pluck('data'),
        switchMap(getData$),
      ),
    };
  },
  methods: {
    goToItem({ id }) {
      this.$router.push({
        path: `${this.$route.path}/${id}`,
      });
    },
    onRowSelected(items) {
      this.selected = items;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/scss/data-table/list-table-content';
@import '../../assets/scss/listing/header';

.addButton {
  padding-top:25px;
}

h4 {
  color: #174169;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 25px;
  margin-bottom: 1rem;
}
</style>
